// skeleton/app/src/app/supervisor-mapping/supervisor-mapping.component.ts

import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
//import { MatTableDataSource, Sort } from '@angular/material';
import { Router } from '@angular/router';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { filter } from 'jszip';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrganizationModel } from '../admin/models/organization.model';
import { EntityField } from '../create/models/entity.model';
import { EntityInstance } from '../incident/incident.component';
import { CardService } from '../shared/components/view/card/card.service';
import { Constants } from '../shared/constants';
import { EntityMaster } from '../shared/models/entityMaster.model';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { NotificationService } from '../shared/services/notifications.service';
import { ParamService } from '../shared/services/param.service';
import { MatTableDataSource } from '@angular/material/table';
import { StorageService } from '../shared/services/token-storage.service';

export class FilterValues {
  key: string;
  value: string;
}

@Component({
  selector: 'app-supervisor-mapping',
  templateUrl: './supervisor-mapping.component.html',
  styleUrls: ['./supervisor-mapping.component.scss'],
  standalone: false
})
export class SupervisorMappingComponent implements OnInit {
  displayedColumns: string[] = [];
  filterValues: FilterValues[];
  editingrow: boolean = false;
  selectedEntityInstance: EntityInstance;
  fieldData: any;
  totalItems: any;
  filter: {};
  data: any = [];
  size = 5;
  pageIndex = 0;
  loggedInUserTypeId: string;
  defaultGroup: any;
  selectedEntity: EntityMaster;
  searchableFields: EntityField[] = [];
  resultFields: EntityField[] = [];
  infoBarFields: EntityField[] = [];
  selectedProcessId: string;
  defaultOrgId: any;
  selectedProcess: EntityMaster;
  panelOpenState: boolean = false;
  loggedInUserGroup: any;
  orgValues: OrganizationModel[] = [];
  dataSource: any;
  constant: Constants = new Constants();
  supervisorList: any;
  selectedValue: string;
  entities: EntityMaster[] = [];
  arrowIconToggle: boolean = false;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  entityIndex: number = 0;
  defaultSelectedSup: string;

  searchForm = new FormGroup({
    entityControl: new FormControl(new EntityMaster()),
    search: new FormControl(''),
    dynamicControls: this.fb.group({}),
  });

  constructor(
    private notificationService: NotificationService,
    private baseHttpService: BaseHttpService,
    private router: Router,
    private fb: FormBuilder,
    private paramservice: ParamService,
    private datePipe: DatePipe,
    private globalsession: GlobalsessionhandlerService,
    private cardservice: CardService,
    private spinnerService: NgxSpinnerService,
    private storage: StorageService
  ) { }

  changeArrowIcon() {
    this.arrowIconToggle = !this.arrowIconToggle;
  }

  async ngOnInit() {
    this.loggedInUserTypeId = this.storage.get("LoggedInUserTypeId");
    this.defaultGroup = this.storage.get("UserGroupId");
    this.defaultOrgId = this.storage.get("OrganizationId");

    if (this.loggedInUserTypeId == '1' || this.loggedInUserTypeId == '5') {
      this.spinnerService.show();
      this.baseHttpService.get(this.constant.getAllOrgs).subscribe(async (result) => {
        if (result) {
          this.orgValues = result;

          if (this.loggedInUserTypeId == '5') {
            this.orgValues.forEach(element => {
              this.defaultOrgId = element.groups
                .filter(x => x.groupId == this.defaultGroup)
                .map(s => s.organizationId)[0];
            });

            await this.getEntities(this.defaultGroup, false);
            await this.getSupervisors(this.defaultOrgId);
          } else {
            await this.getEntities(this.defaultGroup, false);
            await this.getSupervisors(this.defaultOrgId);
          }
        } else {
          this.spinnerService.hide();
        }
      });
    } else {
      this.getEntities(this.defaultGroup, false);
    }
  }

  onRowEditInit(entityInstance) {
    this.editingrow = true;
    this.selectedEntityInstance = entityInstance.label;
  }

  onRowEditCancel(entityInstance) {
    this.editingrow = false;
    this.selectedEntityInstance = entityInstance.label;
    this.getEntities(this.defaultOrgId, true);
  }

  async getEntities(orgId, isOrg) {
    this.spinnerService.show();
    if (orgId != null && orgId != undefined && orgId != "") {
      this.baseHttpService.get(this.constant.getEntitiesbyOrg + "/" + orgId + "/" + isOrg).subscribe(async (result) => {
        if (result != null && result.length > 0) {
          this.entities = result;
          if (this.entities.length > 0) {
            this.entities.forEach(x => {
              x["isSelected"] = false;
            });
            this.onClickOfProcess(this.entityIndex);
          }
        } else {
          this.selectedEntity = new EntityMaster();
          this.entities = [];
          this.data = [];
          this.dataSource = new MatTableDataSource([]);
          this.spinnerService.hide();
        }
      });
    }
  }

  paginate(event: any) {
    if (event == 0) {
      event = 1;
    }
    this.pageIndex = event;
    this.getEntities(this.defaultOrgId, true);
  }

  onClickOfProcess(index: number) {
    this.spinnerService.show();
    this.entityIndex = index;
    this.panelOpenState = false;

    this.entities.forEach(x => {
      x["isSelected"] = false;
    });

    this.selectedProcess = new EntityMaster();
    this.selectedProcess = this.entities[index];
    this.selectedEntity = this.entities[index];
    this.entities[index]["isSelected"] = true;
    this.selectedProcessId = this.selectedProcess.entityID;

    this.getTableData(this.selectedProcessId);
  }

  filterOpen(event) {
    this.panelOpenState = true;
    this.filterEntityFields();
  }

  filterEntityFields() {
    this.searchableFields = [];
    this.resultFields = [];

    this.selectedEntity.entityFields.forEach(ef => {
      ef.fieldProperties.forEach(p => {
        if (p.propertyDetails.propertyName == "Searchable" && p.propertyValue == "1") {
          let itemFoundSearch = this.resultFields.filter(x => x.entityFieldID == ef.entityFieldID)[0];
          if (itemFoundSearch == null) {
            this.searchableFields.push(ef);
          }
        }

        if (p.propertyDetails.propertyName == "Display In Results" && p.propertyValue == "1") {
          let itemFound = this.resultFields.filter(x => x.entityFieldID == ef.entityFieldID)[0];
          if (itemFound == null) {
            this.resultFields.push(ef);
          }
        }

        if (p.propertyDetails.propertyName == "Display in info-bar" && p.propertyValue == "1") {
          let itemFound = this.infoBarFields.filter(x => x.entityFieldID == ef.entityFieldID)[0];
          if (itemFound == null) {
            this.infoBarFields.push(ef);
          }
        }
      });
    });
  }

  async getTableData(entityIdVal, filter?) {
    this.filterEntityFields();
    this.data = [];
    this.dataSource = new MatTableDataSource([]);

    let postModel = {
      entityId: entityIdVal,
      currentPageIndex: this.pageIndex,
      pageSize: this.size,
      pageNumber: this.pageIndex
    };

    if (entityIdVal != null && entityIdVal != undefined && entityIdVal != "") {
      this.baseHttpService.post(this.constant.getEntityInstancesByEntityId, postModel).subscribe((result) => {
        if (result.elementList.length > 0) {
          this.data = result.elementList;
          this.totalItems = result.pageCount * this.size;
          this.fieldData = result.elementList;

          this.displayedColumns = this.resultFields.map(s => s.entityFieldName);
          this.displayedColumns.push("SupervisorId");
          this.displayedColumns.push("Action");

          this.dataSource = new MatTableDataSource(result.elementList);
          this.dataSource.data = this.data;

          console.log(this.data);
          console.log(this.displayedColumns);
          console.log(this.dataSource);

          this.spinnerService.hide();
        } else {
          this.data = [];
          this.dataSource = new MatTableDataSource([]);
          this.spinnerService.hide();
        }
      });
    }
  }

  async getSupervisors(orgId) {
    this.spinnerService.show();
    if (orgId != null && orgId != undefined && orgId != "") {
      this.baseHttpService.getById(this.constant.getSupervisorByOrg, orgId).subscribe((result) => {
        if (result) {
          this.supervisorList = result;
          this.defaultSelectedSup = result[0];
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
    }
  }

  async mapSupervisor(entityInstance) {
    console.log(this.selectedValue, entityInstance);
    this.spinnerService.show();

    if (entityInstance != null && entityInstance != undefined) {
      let model = {
        entityInstanceId: entityInstance.label,
        supervisorId: entityInstance.value.SupervisorId == 0
          ? '00000000-0000-0000-0000-000000000000'
          : entityInstance.value.SupervisorId
      };

      this.baseHttpService.post(this.constant.mpEntityInstanceSuper, model).subscribe((result) => {
        if (result) {
          console.log(result);

          this.spinnerService.hide();
          this.notificationService.showSuccess("User Role has been updated successfully.", "Successful!");
          this.getEntities(this.defaultOrgId, true);
          this.editingrow = false;
        } else {
          this.spinnerService.hide();
        }
      });
    }
  }

  async orgChange(event) {
    this.spinnerService.show();
    if (event.value != null && event.value != undefined && event.value != "") {
      await this.getEntities(event.value, true);
      await this.getSupervisors(event.value);
    }
  }

  onSupChange(event, val) {
    console.log(event, val);
    console.log(this.dataSource);

    this.dataSource.data.forEach(element => {
      if (element.label == val.label) {
        element.value["SupervisorId"] = event.value;
      }
    });
  }

  async applyFilters(event) {
    this.filterValues = [];

    if (this.searchableFields) {
      this.searchableFields.forEach(element => {
        let filterValue = new FilterValues();
        let elementValue = (<HTMLInputElement>document.getElementById(element.questionMasters.questionId.toString()));

        if (elementValue.value != null && elementValue.value.toLowerCase().trim().length > 0) {
          filterValue.key = element.questionMasters.questionId.toString();
          filterValue.value = elementValue.name == 'dateField'
            ? this.datePipe.transform(elementValue.value, 'yyyy-MM-dd')
            : elementValue.value;
          this.filterValues.push(filterValue);
        }
      });

      this.data = [];
      this.dataSource = new MatTableDataSource([]);

      let postModel = {
        entityId: this.selectedEntity.entityID,
        currentPageIndex: this.pageIndex,
        pageSize: this.size,
        pageNumber: this.pageIndex,
        filters: this.filterValues
      };

      this.spinnerService.show();
      if (this.selectedEntity.entityID != null && this.selectedEntity.entityID != undefined && this.selectedEntity.entityID != "") {
        this.baseHttpService.post(this.constant.getEntityInstancesByEntityId, postModel).subscribe((result) => {
          if (result.elementList.length > 0) {
            this.data = result.elementList;
            this.totalItems = result.pageCount * this.size;
            this.fieldData = result.elementList;

            this.displayedColumns = this.resultFields.map(s => s.entityFieldName);
            this.displayedColumns.push("SupervisorId");
            this.displayedColumns.push("Action");

            this.dataSource = new MatTableDataSource(result.elementList);
            this.dataSource.data = this.data;

            console.log(this.data);
            console.log(this.displayedColumns);
            console.log(this.dataSource);

            this.spinnerService.hide();
          } else {
            this.data = [];
            this.dataSource = new MatTableDataSource([]);
            this.spinnerService.hide();
          }
        });
      }
    }
  }
}
